import React from 'react'
import { Box } from '@mui/material'

const Marker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'inline-block',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: '4px',
        borderColor: theme => theme.palette.secondary.light,
        color: theme => theme.palette.secondary.main,
        px: 1.5,
      }}
    >
      {children}
    </Box>
  )
}

/**
 * A piece of text appended to charging sessions to signify if they are MID certified.
 */
export const MIDCertificationMarker: React.FC = () => <Marker>MID</Marker>

/**
 * A piece of text appended to charging sessions to signify if their auth type is OCPP.
 */
export const PROAuthenticationMarker: React.FC = () => <Marker>PRO</Marker>
